(function($, undefined) {
	
	'use strict';
	var utils = Fw.component.models().utils; 

	var init = function (page) {
		var currPage = $(page);
		
		$('.inverse-padding-img-ctn').click(function() {
			var leftDiv = $(this).siblings('.lining-double-wrapper').eq(0);
			var rightDiv = $(this).siblings('.lining-double-wrapper').eq(1);
			var componentId = $(this).siblings('.lining-double-wrapper').eq(0).attr('id').replace('lining-double-wrapper-', '');
			
			var value = "";
			if (leftDiv.hasClass('padding-top')) {
				leftDiv.removeClass('padding-top');
				rightDiv.removeClass('padding-top');
				value = "0";
			} else if (rightDiv.hasClass('padding-top')) {
				leftDiv.addClass('padding-top');
				rightDiv.removeClass('padding-top');
				value = "1";
			} else {
				leftDiv.removeClass('padding-top');
				rightDiv.addClass('padding-top');
				value = "2";
			}
			var labelKey = "lining-double-inverse-" + componentId;

			if(utils){
				utils.updateLabelLangs(labelKey, value, 'en,fr');
			}	
		});
	};
	
	var liningDouble = Fw.modules.export('liningDouble', {
		init: init
	});
	
})(jQuery);

